import React from "react";
import { DeleteOutline } from "@mui/icons-material";
import styled from "@emotion/styled";

const CartItem = ({
  item,
  error,
  disabled,
  onDecrease,
  onIncrease,
  onDelete,
}) => {
  return (
    <CartItemContainer>
      <ProductImageContainer>
        <ProductImage
          src={
            (item?.images && item?.images[0]) || "/images/no_product_image.png"
          }
          alt="Product"
        />
      </ProductImageContainer>
      <ProductDetails>
        <BrandName>{item.brand_name}</BrandName>
        <ProductName>{item.product_name}</ProductName>
        <div>{`Qty: ${item?.quantity}`}</div>
        <div>
          {`Total: $${(item?.finalPrice * item?.quantity).toFixed(2)} `}
          {error?.validation === "price_increase" && (
            <ErrorText>(recent price increase)</ErrorText>
          )}
        </div>
        <div style={{ height: 10 }} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <QuantityControls>
              <QuantityButton
                onClick={onDecrease}
                disabled={disabled}
              >
                -
              </QuantityButton>
              <QuantityButton as="span" style={{ fontSize: "1rem" }}>
                {item.quantity}
              </QuantityButton>
              <QuantityButton
                onClick={onIncrease}
                disabled={disabled}
              >
                +
              </QuantityButton>
            </QuantityControls>
          </div>
          <div style={{ display: "flex", alignItems: "center", padding: "0px 10px" }}>
            <DeleteButton onClick={onDelete} disabled={disabled}>
              <DeleteIcon />
            </DeleteButton>
          </div>
        </div>
      </ProductDetails>
    </CartItemContainer>
  );
};

const CartItemContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  margin-bottom: 5px;
  border-radius: 8px;
`;

const ProductImageContainer = styled.div`
  display: block;
  flex: 1;
  margin-right: 10px;
  padding: 10px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ProductDetails = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  color: black;
  padding: 10px 0;
  line-height: 1.3;
  @media (min-width: 900px) {
    font-size: 1.2rem;
  }
`;

const BrandName = styled.div`
  font-weight: 600;
`;

const ProductName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

const ErrorText = styled.span`
  font-size: 14px;
  color: #ff0c0c;
`;

const QuantityControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 5px 0;
  border-radius: 50px;
`;

const QuantityButton = styled.p`
  width: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1.3rem;
  user-select: none;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const DeleteButton = styled.button`
  font-size: 12px;
  color: blue;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background: none;
  border: none;
  padding: 0;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  display: flex;
  align-items: center;
`;

const DeleteIcon = styled(DeleteOutline)`
    color: black;
    @media (min-width: 900px) {
        font-size: 30px;
    }
`;

export default CartItem;
